import { Tabs } from 'antd';
import styled from 'styled-components';

export const Main = styled.div<{ $private?: 'true' | 'false' }>`
  display: flex;
  flex-direction: column;
  .ant-tabs {
    overflow: inherit;
  }
`;

export const StyledTabs = styled(Tabs)`
  &,
  .ant-tabs-content-holder,
  .ant-tabs-content {
    height: 100%;
  }
  .ant-tabs-nav {
    padding: 0 var(--layout-03);
    margin: 0px;
  }
  .ant-tabs-tabpane {
    overflow: hidden;
  }
`;

export const TabPaneScrollWrapper = styled.div`
  padding: 0 var(--layout-03) var(--layout-04);
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
`;
